function addSchema(schema) {
	const script = document.createElement("script");

	script.type = "application/ld+json";
	script.textContent = JSON.stringify(schema, null, 4);

	document.head.appendChild(script);
}

function srvItem(srv, ccy) {
	return {
		"@type": "Product",
		"url": `${location.origin}/booking/${srv.srv_id}`,
		"name": srv.title,
		"description": srv.descr.substring(0, 500),
		"image": `${location.origin}/api/srv/${srv.srv_id}/img/logo?v=${srv.updated || srv.created}`,
		"brand": {
			"@type": "Brand",
			"name": srv.org_name
		},
		"offers": {
			"@type": "Offer",
			"priceCurrency": srv.ccy_id || ccy,
			"price": srv.price / 100
		},
		...srv.rating !== null && srv.rating_cnt !== null && {
			aggregateRating: {
				"@type": "AggregateRating",
				"worstRating": 1,
				"bestRating": 5,
				"ratingValue": Number(srv.rating),
				"ratingCount": srv.rating_cnt
			}
		}
	};
}

function srvItems(srvs, ccy) {
	const items = [];

	for (let i = 0; i < srvs.length; i++) {
		items.push({
			"@type": "ListItem",
			"position": i + 1,
			"item": srvItem(srvs[i], ccy)
		});
	}

	return items;
}

export function addSrvSchema(srv, ccy) {
	addSchema({
		"@context": "https://schema.org",
		...srvItem(srv, ccy)
	});
}

export function addSrvsSchema(srvs, ccy) {
	addSchema({
		"@context": "https://schema.org",
		"@type": "ItemList",
		"itemListElement": srvItems(srvs, ccy)
	});
}
